export const PurchasePaymentEnI18n = {
    title: 'Submit Payment',
    checklist: {
        accountVerified: 'Account verification complete',
        documentSigned: 'Subscription document signed',
        paymentMethodAdded: 'Payment method added',
    },
    authorization: {
        descr: `By clicking ‘Submit Payment’ you authorize this transaction and agree to our <a data-link="tosLink"></a> and <a data-link="eftDisclosureLink"></a>`,
        validators: {
            required: 'Please provide the authorization before proceeding',
        },
    },
    actions: {
        submit: 'Submit Payment',
        back: 'Back',
    },
    linkConfigs: [
        {
            key: 'tosLink',
            link: 'bazaCommon.links.termsOfService',
            isCMSLink: true,
            text: 'Terms of Service',
        },
        {
            key: 'eftDisclosureLink',
            link: 'bazaCommon.links.eftDisclosure',
            isCMSLink: true,
            text: 'EFT Disclosure',
        },
    ],
};
